import { configureErrorTrackingService } from "../exceptions";
import { sharedEnvironment } from "../../config/environmentService";

export const errorTrackingService = configureErrorTrackingService(
  sharedEnvironment.environment,
  sharedEnvironment.sentryDsn,
);
